export default {
  checkout: () => import("/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/layouts/default.vue").then(m => m.default || m),
  embed: () => import("/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/layouts/embed.vue").then(m => m.default || m),
  org: () => import("/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/layouts/org.vue").then(m => m.default || m),
  profile: () => import("/Users/ted/workspace/rphq/rphq-redpoint-api-v1/cpx/layouts/profile.vue").then(m => m.default || m)
}